import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = [
    "BolFileInput"
  ]

  get trackingModalController() {
    return document.querySelector(`[data-controller="tracking-modal"]`)[`tracking-modal`]
  }

  connect() {
    this.element[this.identifier] = this
  }

  onUploadBolClick(e) {
    e.preventDefault()

    this.BolFileInputTarget.click()
  }

  onBolFileChange(e) {
    e.preventDefault()

    e.target.form.requestSubmit()
  }

  onUploadBolDragover(e) {
    e.currentTarget.classList.add("bg-gray-200")
  }

  onUploadBolDragleave(e) {
    e.currentTarget.classList.remove("bg-gray-200")
  }

  onEditClick(e) {
    e.preventDefault()
    e.stopPropagation()

    const resourceId = e.currentTarget.dataset.resourceId
    const resourceType = e.currentTarget.dataset.resourceType

    this.trackingModalController.openModal(resourceId, resourceType)
  }

  onEmailTrackingClick(e) {
    e.stopPropagation()
  }

  stopPropagation(e) {
    e.stopPropagation()
  }

}
